import React from "react";

export default function SectionTitle({ title, className = "mt-10" }) {
  return (
    <h1
      style={{ textAlign: "center" }}
      className={`${className} flex flex-wrap items-baseline justify-center gap-x-2 text-3xl text-center`}
    >
      <span className="section-title-bracket" aria-hidden="true">
        &lt;
      </span>
      <span className="blue-underline">{title}</span>
      <span className="section-title-bracket" aria-hidden="true">
        &gt;
      </span>
    </h1>
  );
}
